import $ from 'jquery';
import View from 'mixins/view';
import tippy from 'tippy.js';
import moment from 'moment';

export class CommentSocioView extends View {
    constructor(model) {
        super(model);

        this.premium = model.get('User').get('premium');
        const $html = $(`<span class="uch-socio">SOCIO</span>`);

        this.setRootEl($html);
    }
    render() {
        this.setRootEl('');
        // return;

        // this.getRootEl()
        //     .addClass(`uch-socio-${this.premium.type}`)
        //     .attr('data-date', this.premium.start.date)
        //     .attr('data-no', this.premium.no)
        //     .attr('data-type', this.premium.type);
    }
}

export function buildCommentSocioTippies(parent) {
    tippy(parent, {
        onShow(instance) {
            // const reference = instance.reference;
            // const { date, no, type } = reference.dataset;
            // const format = moment(date).format('D MMMM YYYY');
            //
            // let theme = 'gold';
            //
            // switch (type) {
            //     case '2':
            //         theme = 'silver';
            //         break;
            //     case '3':
            //         theme = 'brown';
            //         break;
            // }
            // theme = `user-socio-popover usp-${theme}`;
            //
            // let content = 'Socio';
            // content += no ? ` nr ${no}` : '';
            // content += ` od ${format}`;
            //
            // instance.setContent(content);
            // instance.set({ theme: theme });
        },
        target: '.uch-socio',
        trigger: 'click',
        arrow: true,
        arrowType: 'round',
        placement: 'bottom',
        sticky: true,
        delay: 0,
        duration: [0, 0],
    });
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comment-socio-view.js